export default ngInject(function($uibModalInstance, form, vendorEmail, $filter) {
  this.form = form;
  this.vendorEmail = vendorEmail;
  this.dropoffWindowLabel = (dropoffWindow) => {
    const formattedLabel = (() => {
      switch (dropoffWindow) {
        case 'third-party-carrier':
          return 'by';
        case 'backhaul':
          return 'by';
        default:
          return 'between';
      }
    })();
    return `${formattedLabel} ${dropoffWindow}`;
  };

  // TODO(serhalp) this is duplicated in several places - remove and call helper
  this.getCatalogProductLabel = (catalogProduct) => {
    if (catalogProduct == null) {
      return '';
    }
    if ((catalogProduct != null ? catalogProduct.sku : undefined) != null) {
      return `(${catalogProduct.sku}) ${catalogProduct.name}`;
    }
    return catalogProduct.name;
  };

  // TODO(serhalp) this is duplicated in several places - remove and call helper
  this.displayLineItemName = (lineItemForm) => {
    const displayOrderUnit = $filter('displayOrderUnit');
    const {catalogProduct} = lineItemForm;

    if (catalogProduct != null) {
      const catalogProductDisplayOrderUnit = displayOrderUnit(catalogProduct);
      const displayUnit =
        catalogProductDisplayOrderUnit != null
          ? catalogProductDisplayOrderUnit
          : catalogProduct.unitQuantityLabel;
      if (catalogProduct.sku != null) {
        return `(${catalogProduct.sku}) ${displayUnit}`;
      }
      return `${displayUnit}`;
    }
    return undefined;
  };

  // Note, this only works when field name is the same as lineItem prop name
  this.isDifferentThanPreviousSubmission = (lineItemForm, field) =>
    lineItemForm.isFieldEdited(field);

  this.sortByLineItemNumber = (lineItem) => lineItem.number || Infinity;

  this.submit = (params) => $uibModalInstance.close(params);

  this.cancel = () => $uibModalInstance.dismiss();

  return this;
});
